<template>
	<div class="overall-asmnt-bg">
		<div class="overall-asmnt-main-container overallasmntreports">
			<div class="headtext d-flex align-items-center">
				<div class="pointer" v-if="$route.query.redirect">
					<img
						class="pb-1"
						src="../../../assets/icons/Reports/bckarrow.svg"
						alt=""
						@click="goTobackpage()"
					/>
				</div>

				<div class="ml-3 heading mr-3">
					<span>Reports</span>
				</div>
			</div>
			<div
				style="
          position: fixed;
          top: 20px;
          z-index: 1;
          backdrop-filter: blur(2px);
        "
				v-if="LoaderStatus"
			>
				<Spinner />
			</div>
			<div class="d-flex mt-3">
				<div style="width: 80%">
					<div
						class="reports-top-bar  d-flex align-items-center justify-content-between"
						:class="this.filterSelected != 'custom' ? 'parent-1' : 'parent-2'"
					>
						<div class="rep-overview-text">An overview of all reports</div>
						<div class="box">
							<section>
								<b-form-radio-group
									id="btn-radios-2"
									v-model="filterSelected"
									:options="filterOptions"
									button-variant="outline-secondary"
									name="radio-btn-outline"
									buttons
									@change="changeState()"
								></b-form-radio-group>
								<date-picker
									v-model="value1"
									type="date"
									range
									placeholder="Custom"
									@input="filterSelected = 'custom'"
								></date-picker>
							</section>
						</div>
					</div>
					<div class="mt-2">
						<b-row>
							<b-col>
								<div class="rep-chota-cards position-relative">
									<div class="rep-c-mainhead">Topics</div>
									<div class="rep-c-subhead">Active Topics</div>
									<div class="d-flex position-relative">
										<div class="rep-c-counttxt" style="color: #8b66ba">
											{{ totalTopicCount }}
										</div>
										<div v-if="activeTags === `topics`" class="expandicon">
											<img
												src="../../../assets/icons/expandactive.svg"
												alt="topicdiv"
												@click="scrollfunction('scatter1Scroll', 'topics')"
											/>
										</div>
										<div v-else class="expandicon">
											<img
												src="../../../assets/icons/expandnonactive.svg"
												alt="topicdiv"
												@click="scrollfunction('scatter1Scroll', 'topics')"
											/>
										</div>
									</div>
									<div
										v-if="activeTags === `topics`"
										class="rep-c-activeline"
									></div>
								</div>
							</b-col>
							<b-col>
								<div class="rep-chota-cards position-relative ml-2">
									<div class="rep-c-mainhead">Tests</div>
									<div class="rep-c-subhead">Active Tests</div>
									<div class="d-flex position-relative">
										<div class="rep-c-counttxt" style="color: #8b66ba">
											{{ totalTestCount }}
										</div>
										<div v-if="activeTags === `test`" class="expandicon">
											<img
												src="../../../assets/icons/expandactive.svg"
												alt=""
												@click="scrollfunction('barScroll', 'test')"
											/>
										</div>
										<div v-else class="expandicon">
											<img
												src="../../../assets/icons/expandnonactive.svg"
												alt=""
												@click="scrollfunction('barScroll', 'test')"
											/>
										</div>
									</div>
									<div
										v-if="activeTags === `test`"
										class="rep-c-activeline"
									></div>
								</div>
							</b-col>
							<b-col>
								<div class="rep-chota-cards position-relative ml-2">
									<div class="rep-c-mainhead">Candidates</div>
									<div class="rep-c-subhead">Candidates Taken Test</div>
									<div class="d-flex position-relative">
										<div class="rep-c-counttxt" style="color: #329daf">
											{{ totalCandidateCount }}
										</div>
										<div v-if="activeTags === `candidate`" class="expandicon">
											<img
												src="../../../assets/icons/expandactive.svg"
												alt=""
												@click="scrollfunction('barScroll', 'candidate')"
											/>
										</div>
										<div v-else class="expandicon">
											<img
												src="../../../assets/icons/expandnonactive.svg"
												alt=""
												@click="scrollfunction('barScroll', 'candidate')"
											/>
										</div>
									</div>
									<div
										v-if="activeTags === `candidate`"
										class="rep-c-activeline"
									></div>
								</div>
							</b-col>
							<b-col>
								<div class="rep-chota-cards position-relative ml-2">
									<div class="rep-c-mainhead">Groups</div>
									<div class="rep-c-subhead">Active Groups</div>
									<div class="d-flex position-relative">
										<div class="rep-c-counttxt" style="color: #3379b3">
											{{ totalGroupCount }}
										</div>
										<div v-if="activeTags === `group`" class="expandicon">
											<img
												src="../../../assets/icons/expandactive.svg"
												alt=""
												@click="scrollfunction('scrollScatter2', 'group')"
											/>
										</div>
										<div v-else class="expandicon">
											<img
												src="../../../assets/icons/expandnonactive.svg"
												alt=""
												@click="scrollfunction('scrollScatter2', 'group')"
											/>
										</div>
									</div>
									<div
										v-if="activeTags === `group`"
										class="rep-c-activeline"
									></div>
								</div>
							</b-col>
							<b-col>
								<div class="rep-chota-cards position-relative ml-2">
									<div class="rep-c-mainhead">Candidates</div>
									<div class="rep-c-subhead">Candidates Added</div>
									<div class="d-flex position-relative">
										<div class="rep-c-counttxt">
											{{ totalCandidatesAddedCount }}
										</div>
										<div v-if="activeTags === `individual`" class="expandicon">
											<img
												src="../../../assets/icons/expandactive.svg"
												alt=""
												@click="scrollfunction('dendogram', 'individual')"
											/>
										</div>
										<div v-else class="expandicon">
											<img
												src="../../../assets/icons/expandnonactive.svg"
												alt=""
												@click="scrollfunction('dendogram', 'individual')"
											/>
										</div>
									</div>
									<div
										v-if="activeTags === `individual`"
										class="rep-c-activeline"
									></div>
								</div>
							</b-col>
						</b-row>
					</div>
					<div class="rep-overview-container mt-2">
						<b-overlay
							:show="showSpinnerScatter"
							spinner-type="grow"
							spinner-large
							rounded="sm"
							label="Text Centered"
						>
							<div class="rep-topic-conatiner p-3" id="scatter1Scroll">
								<div class="rep-tp-headtext">Topics</div>

								<div class="d-flex justify-content-between">
									<div class="position-relative w-50" ref="qbdropdiff">
										<div
											@click="topicDown = !topicDown"
											class="item grp-second-section"
										>
											<span class="grp-search-bar-search">
												<img
													class="ml-2"
													src="../../../assets/searchicon.svg"
													alt=""
												/>
												<b-form-input
													class="grp-search-bar-searchbtn"
													v-model="searchTopics"
													placeholder="Search Topics"
													ref="typeBox"
												>
												</b-form-input>
											</span>
										</div>
										<div
											v-if="topicDown"
											class="grp-candidates-overflow mt-1 position-absolute w-100"
											ref="topicDown"
											v-closable="{
												exclude: ['qbdropdiff'],
												handler: 'hideSearchTopics',
											}"
										>
											<div
												v-if="
													searchTopics === '' && filteredTopics.length === 0
												"
												class="grp-tagged-test-head mt-2 d-flex justify-content-center"
											>
												No Topics Created
											</div>
											<div v-else-if="filteredTopics.length !== 0">
												<div
													v-for="(topics, ind) in filteredTopics"
													:key="topics + [ind]"
													class="d-flex align-items-center p-2"
												>
													<div></div>
													<div
														class="ml-2 grp-tagged-test-head pointer"
														style="word-break: break-all"
														@click="copytheTopicName(topics)"
														:class="
															topics === searchTopics ? 'ovall-selected' : ''
														"
													>
														{{ topics }}
													</div>
												</div>
											</div>

											<div
												v-else-if="
													searchTopics !== '' && filteredTopics.length == 0
												"
												class="grp-tagged-test-head mt-2 d-flex justify-content-center"
											>
												No Topics found
											</div>
										</div>
									</div>
									<div>
										<div
											@click="uniqueTopics != 0 ? reset_zoom() : ''"
											class=" ovall-reset-btn"
											:class="uniqueTopics != 0 ? 'pointer' : ''"
										>
											RESET
										</div>
									</div>
								</div>
								<div class="rep-tp-graph-container d-flex mt-2 p-2">
									<!-- Graph 1 Bubble chart -->
									<div class="rep-graph-seventy p-2" id="scatterPlotGraph1">
										<div
											v-if="!dataExist"
											class="d-flex justify-content-center align-items-center h-100"
										>
											<img
												src="../../../assets/notopicdata.svg"
												class="ml-2"
												alt=""
											/>

											<!-- GRAPH Creation Over Here -->
										</div>
										<div v-else>
											<div
												class="d-flex justify-content-end h-10"
												id="resetScatter1"
											>
												<span v-b-tooltip.hover.top="'Zoom In | Zoom Out'">
													<img
														src="../../../assets/hoverZoomimg.svg"
														alt="topicdiv"
													/>
												</span>
											</div>
											<div id="graph1" class="zoom-in"></div>
										</div>
									</div>

									<div class="rep-graph-twenty position-relative p-2">
										<div class="rep-tp-count">{{ uniqueTopics }}</div>
										<div class="rep-tp-tw-txt">Topics</div>
										<div style="display: flex; flex-direction: column">
											<img
												src="../../../assets/topicProgress.svg"
												class="w-100"
												alt=""
											/>
											<div
												class="d-flex d-flex justify-content-between activeText w-100"
											>
												<div class="ml-2">Less Active</div>
												<div class="mr-2">Most Active</div>
											</div>
										</div>
										<!-- end of search bar -->

										<div class="rep-txt-viewalltxt">
											View all Topics
											<img
												src="../../../assets/rightnxt.svg"
												class="ml-2"
												alt=""
											/>
										</div>
									</div>
								</div>
							</div>
						</b-overlay>

						<div class="rep-test-conatiner mt-2 p-3">
							<div class="rep-tp-headtext" id="barScroll">
								Tests - Candidates Summary
							</div>
							<div class="repotp-test-bar-container mt-3">
								<div
									class="mt-3 reptest d-flex align-items-center justify-content-between"
								>
									<div class="pointer">
										<div
											id="tests"
											@click="changeCandidateTest('tests')"
											:class="!testCandidate ? 'p-2 rep-tst-headcard' : 'p-2'"
										>
											<div
												:class="
													!testCandidate ? 'rep-test-gridcolor' : 'rep-test'
												"
											></div>
											<span>Test</span>
										</div>
										<div
											id="candid"
											@click="changeCandidateTest('candid')"
											:class="testCandidate ? 'p-2 rep-tst-headcard' : 'p-2'"
										>
											<div
												:class="
													testCandidate ? 'rep-test-gridcolor' : 'rep-test'
												"
											></div>
											<span>Candidate</span>
										</div>
									</div>
									<div>
										<b-form-radio-group
											id="btn-radios-3"
											v-model="testfilterSelected"
											:options="testfilterOptions"
											button-variant="outline-secondary"
											name="radio-btn-outline"
											buttons
											@change="testingfunction()"
										></b-form-radio-group>
									</div>
								</div>
								<div class="mt-3">
									<!-- Bargraph graph 2 -->
									<div>
										<div
											class="bar-chart-legend ml-5 barchart"
											id="barchartGraph"
										></div>
									</div>
								</div>
							</div>

							<div class="overalltestprog-container mt-3" id="pie-height">
								<div class="overalltestprog-container-headtext mb-2">
									<span>Overall Test Progress</span>
								</div>
								<b-row class="h-100">
									<b-col cols="5">
										<div id="pieChart"></div>
									</b-col>
									<b-col cols="7">
										<div
											class="d-flex align-items-center justify-content-between"
										>
											<div style="width: 50%">
												<div class="d-flex align-items-center">
													<div>
														<img
															src="../../../assets/icons/Reports/tp-yellow-cir.svg"
															alt=""
														/>
													</div>
													<div class="rep-otp-uptest-txt ml-2">
														{{ upcomingTest }}
													</div>
												</div>
												<div class="rep-otp-subhead mt-1">Upcoming Test</div>
												<div
													class="d-flex align-items-center mt-1"
													style="width: 50%"
												>
													<div class="rep-otp-desc" style="width: 70%">
														Total Candidates
													</div>
													<div style="width: 5%"></div>
													<div class="rep-otp-subhead" style="width: 25%">
														{{ takenTest }}
													</div>
												</div>
											</div>
											<div style="width: 50%">
												<div class="d-flex align-items-center">
													<div>
														<img
															src="../../../assets/icons/Reports/tp-blue-cir.svg"
															alt=""
														/>
													</div>
													<div class="rep-otp-ongngtest-txt ml-2">
														{{ ongoingTest }}
													</div>
												</div>
												<div class="rep-otp-subhead mt-1">Ongoing Test</div>
												<div class="d-flex align-items-center mt-1">
													<div class="rep-otp-desc">Total Candidates</div>
													<div class="rep-otp-subhead ml-3">
														{{ ongoingCandidate }}
													</div>
												</div>
											</div>
										</div>
										<div style="width: 50%" class="mt-3">
											<div class="d-flex align-items-center">
												<div>
													<img
														src="../../../assets/icons/Reports/tp-green-cir.svg"
														alt=""
													/>
												</div>
												<div class="rep-otp-comp-txt ml-2">
													{{ completedTest }}
												</div>
											</div>
											<div class="rep-otp-subhead mt-1">Completed Test</div>
											<div
												class="d-flex align-items-center mt-1"
												style="width: 50%"
											>
												<div class="rep-otp-desc" style="width: 70%">
													Passed Candidates
												</div>
												<div style="width: 5%"></div>
												<div class="rep-otp-subhead" style="width: 25%">
													{{ passCandidate }}
												</div>
											</div>
											<div
												class="d-flex align-items-center mt-1"
												style="width: 50%"
											>
												<div class="rep-otp-desc" style="width: 70%">
													Failed Candidates
												</div>
												<div style="width: 5%"></div>
												<div class="rep-otp-subhead" style="width: 25%">
													{{ failCandidate }}
												</div>
											</div>
											<div
												class="d-flex align-items-center mt-1"
												style="width: 50%"
											>
												<div class="rep-otp-desc" style="width: 70%">
													Already Taken Test
												</div>
												<div style="width: 5%"></div>
												<div class="rep-otp-subhead" style="width: 25%">
													{{ alreadyTakenTest }}
												</div>
											</div>
										</div>
									</b-col>
								</b-row>
							</div>
						</div>

						<b-overlay
							:show="showSpinnerRect"
							variant="white"
							opacity="0.46"
							blur="4"
							rounded="sm"
						>
							<div class="ovall-group-card mt-3 p-3">
								<div class="d-flex justify-content-between">
									<div class="d-flex flex-column">
										<span class="rep-tp-headtext">Groups</span>
									</div>
									<div
										class="tot-grp-box d-flex align-items-center justify-content-between"
									>
										<div class="totgrp-txt">Total Groups</div>
										<div class="tot-count ml-4">{{ total }}</div>
									</div>
								</div>
								<div
									style="width: 50%"
									class="position-relative ovall-search-bar mt-4"
								>
									<span style="top: 7px;" class="search-pos">
										<img src="../../../assets/searchicon.svg" alt=""
									/></span>
									<b-form-input
										class="search-input"
										v-model.trim="searchQuery"
										type="search"
										:placeholder="`Search Group Name`"
										id="headerSearch"
									></b-form-input>
								</div>
								<div class="mt-4">
									<div>
										<table class="ovall-form-table">
											<caption></caption>
											<thead>
												<tr>
													<th style="width: 32%" class="text-left p-3">
														Groups
														<template v-if="sortBy == 'groupName'">
															<img
																@click="sort('groupName')"
																v-if="ordering == 1"
																src="../../../assets/icons/share/ascending.svg"
																alt=""
																class="pointer ml-1"
															/>
															<img
																v-else
																@click="sort('groupName')"
																src="../../../assets/icons/share/descending.svg"
																alt=""
																class="pointer ml-1"
															/>
														</template>
														<img
															v-else
															@click="sort('groupName')"
															src="../../../assets/icons/share/nosort.svg"
															alt=""
															class="pointer ml-1"
														/>
													</th>

													<th style="width: 17%" class="text-center">
														Tagged Test
														<template v-if="sortBy == 'taggedTest'">
															<img
																@click="sort('taggedTest')"
																v-if="ordering == 1"
																src="../../../assets/icons/share/ascending.svg"
																alt=""
																class="pointer ml-1"
															/>
															<img
																v-else
																@click="sort('taggedTest')"
																src="../../../assets/icons/share/descending.svg"
																alt=""
																class="pointer ml-1"
															/>
														</template>
														<img
															v-else
															@click="sort('taggedTest')"
															src="../../../assets/icons/share/nosort.svg"
															alt=""
															class="pointer ml-1"
														/>
													</th>
													<th style="width: 17%" class="text-center">
														Candidates
														<template v-if="sortBy == 'candidateCount'">
															<img
																@click="sort('candidateCount')"
																v-if="ordering == 1"
																src="../../../assets/icons/share/ascending.svg"
																alt=""
																class="pointer ml-1"
															/>
															<img
																v-else
																@click="sort('candidateCount')"
																src="../../../assets/icons/share/descending.svg"
																alt=""
																class="pointer ml-1"
															/>
														</template>
														<img
															v-else
															@click="sort('candidateCount')"
															src="../../../assets/icons/share/nosort.svg"
															alt=""
															class="pointer ml-1"
														/>
													</th>
													<th style="width: 17%" class="text-center">
														Created On
														<template v-if="sortBy == 'createdAt'">
															<img
																@click="sort('createdAt')"
																v-if="ordering == 1"
																src="../../../assets/icons/share/ascending.svg"
																alt=""
																class="pointer ml-1"
															/>
															<img
																v-else
																@click="sort('createdAt')"
																src="../../../assets/icons/share/descending.svg"
																alt=""
																class="pointer ml-1"
															/>
														</template>
														<img
															v-else
															@click="sort('createdAt')"
															src="../../../assets/icons/share/nosort.svg"
															alt=""
															class="pointer ml-1"
														/>
													</th>
													<th style="width: 17%" class="text-center">
														Created By
													</th>
												</tr>
											</thead>
											<tbody id="top1">
												<template v-if="scatter2_data.length > 0">
													<div v-for="(group, ind) in scatter2_data" :key="ind">
														<tr
															class="ovall-table-details align-middle ml-1 pointer"
														>
															<td
																style="width: 32%"
																class="text-left pl-3 text-truncate"
															>
																{{ group.groupName }}
															</td>
															<td style="width: 17%" class="text-center">
																{{ group.taggedTest }}
															</td>
															<td style="width: 17%" class="text-center">
																{{ group.candidateCount }}
															</td>
															<td style="width: 17%" class="text-center">
																{{ group.createdAt | datefilter }}
															</td>
															<td style="width: 17%" class="text-center">
																{{ group.createdBy }}
															</td>
														</tr>
													</div>
												</template>
												<div
													v-else
													class="position-relative qpc-ques-container p-4"
												>
													<div
														class="d-flex flex-column align-items-center justify-content-center h-100"
														v-if="searchQuery != ''"
													>
														<div>
															<img
																src="../../../assets/nosearchdataCT.svg"
																alt=""
															/>
														</div>
														<div class="mt-4">
															<span class="searchnotfoundct"
																>No results for
																<span class="searchtextct">
																	"{{ searchQuery }}"
																</span>
																found.</span
															>
														</div>
													</div>
													<div
														class="d-flex flex-column align-items-center justify-content-center h-100"
														v-else-if="searchQuery == '' && !LoaderStatus"
													>
														<div>
															<img
																src="../../../assets/nosearchdataCT.svg"
																alt=""
															/>
														</div>
														<div class="mt-4">
															<span class="searchnotfoundct"
																>No results found.</span
															>
														</div>
													</div>
												</div>
											</tbody>
										</table>
									</div>
									<div
										class="ovall-paginaTion d-flex justify-content-between align-items-center"
									>
										<div class="qb-gotopage-text mr-2">
											<span v-if="pageStart > total">0</span>
											<span v-else>{{ pageStart }}</span> to {{ pageEnd }}

											<span class="pl-1"></span> Items in
											<span class="pr-1"></span>{{ total }}
										</div>

										<div class="pagination" style="width: 50%;">
											<b-pagination
												v-model.number="currentPage"
												@input="goToPageNum()"
												:total-rows="total"
												:per-page="groupCounts"
												align="center"
												first-number
												last-number
											>
												<template #prev-text
													><span
														><img
															src="../../../assets/leftvector.svg"
															alt=""
														/> </span
												></template>

												<template #next-text
													><span
														><img
															src="../../../assets/rightarrow.svg"
															alt=""/></span
												></template>
											</b-pagination>
										</div>
									</div>
								</div>
							</div>
						</b-overlay>

						<b-overlay
							:show="showSpinner"
							spinner-type="grow"
							spinner-large
							rounded="sm"
							label="Text Centered"
						>
							<div class="rep-topic-conatiner mb-2 mt-3 p-3" id="dendogramFull">
								<div
									v-if="!dataExist3"
									class="d-flex justify-content-center align-items-center h-100"
								>
									<img
										src="../../../assets/noQuesTag.svg"
										class="ml-2"
										alt=""
									/>
								</div>
								<div v-else class="h-100">
									<b-row class="h-100">
										<b-col cols="6">
											<div class="rep-tp-headtext ali">Questions</div>
											<div class="rep-tp-subtxt mt-2"></div>
											<div
												class="position-relative w-100"
												ref="expdropdownselectedGroup"
											>
												<div
													@click="toggleDropdownselectedQues()"
													class="item grp-second-section w-100"
												>
													<span class="grp-search-bar-search">
														<img
															class="ml-2"
															src="../../../assets/searchicon.svg"
															alt=""
														/>
														<b-form-input
															class="grp-search-bar-searchbtn"
															v-model="search"
															placeholder="Search Tags"
															ref="typeBoxTag"
														>
														</b-form-input>
													</span>
												</div>
												<div
													v-if="quesDown"
													class="grp-candidates-overflow mt-1 position-absolute w-100"
												>
													<div
														v-if="search === '' && filteredList.length === 0"
														class="grp-tagged-test-head mt-2 d-flex justify-content-center"
													>
														No Tags Created
													</div>

													<div
														v-else-if="filteredList.length !== 0"
														class="ovall-selectdropdown"
													>
														<!-- BY Checkbox -->
														<b-form-checkbox
															class="ovall-width "
															v-for="(tags, ind) in filteredList"
															:key="tags + ind"
															:value="tags"
															v-model="selectedFilteredTag"
															@change="makeNewLinkGraph()"
														>
															{{ tags }}
														</b-form-checkbox>
													</div>

													<div
														v-else-if="
															search !== '' && filteredList.length == 0
														"
														class="grp-tagged-test-head mt-2 d-flex justify-content-center"
													>
														No Tags Found
													</div>
												</div>
											</div>
										</b-col>
										<b-col cols="2"> </b-col>
										<b-col class="h-100" cols="4">
											<div
												class="d-flex align-items-center justify-content-end"
											>
												<div
													class="tot-grp-box mt-2 d-flex align-items-center justify-content-between"
												>
													<div class="totgrp-txt">Total Tags</div>

													<div class="tot-count ml-4">{{ totalTags }}</div>
												</div>
												<div
													class="tot-grp-box mt-2 ml-2 justify-content-end d-flex align-items-center justify-content-between"
												>
													<div class="totgrp-txt">Total Questions</div>
													<div class="tot-count ml-4">{{ totalQuestions }}</div>
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col class="pl-3">
											<span class="rep-tp-subtxt d-flex mt-3"
												>Applied Tags :</span
											>
											<div
												style="border-bottom: 1px solid grey;"
												class="d-flex align-items-center justify-content-between mt-2 pb-3"
											>
												<div class="d-flex align-items-center flex-wrap">
													<div
														v-if="selectedFilteredTag.length == 0"
														class="archivebox-heading"
													>
														No flters applied
													</div>
													<!-- <div v-else> -->
													<div v-for="(val, i) in selectedFilteredTag" :key="i">
														<div class="ovall-tags">
															{{ val }}
															<img
																class="ml-2 pointer"
																src="../../../assets/greyCross.svg"
																alt=""
																@click="deleteTagsFromList(val)"
															/>
														</div>
													</div>
													<div
														class="grp-tagged-test-head ml-4 pointer"
														v-if="selectedFilteredTag.length != 0"
														@click="setBackLinkGraph"
													>
														Clear All
													</div>
												</div>
											</div>
											<div class="d-flex">
												<div style="width: 65%;">
													<!-- Dendogram graph tree structure -->
													<div id="dendogram"></div>
												</div>
												<div style="width: 35%;">
													<div
														v-if="!showQuesTag"
														class="w-100"
														style="margin-top: 20%;"
													>
														<img src="../../../assets/noTagQues.svg" alt="" />
													</div>
													<div
														v-else
														class="w-100 d-flex align-items-center mt-2 ml-3"
													>
														<div class="reports-heading position-relative mt-5">
															<div class="d-flex justify-content-between mt-2">
																<div class="reports p-3">
																	<div class="linegraph-text">
																		Questions count for
																		{{ filterSelected }} basis
																	</div>
																	<div class="linegraph-text mt-2">
																		Tags: {{ actualTags.length }}
																	</div>
																</div>
																<div class="closeText">
																	<img
																		src="../../../assets/closeBtn.svg"
																		class="p-3 pointer"
																		alt=""
																		@click="
																			(showQuesTag = false), (search = '')
																		"
																	/>
																</div>
															</div>
															<b-overlay
																:show="showQuesTagSpinner"
																variant="white"
																opacity="0.46"
																blur="4"
																rounded="sm"
															>
																<div class="reports-lineGraphallText">
																	<div
																		v-for="(i, index) in actualTags"
																		:key="index"
																	>
																		<div
																			class="position-relative"
																			:class="
																				index == 0
																					? ''
																					: 'mt-1 linegraph-subtext'
																			"
																			style="background: rgba(252, 252, 252, 0.95)"
																		>
																			<div class="linegraphColorbar"></div>

																			<div
																				class="d-flex align-items-center linegraph-subtext-Parent"
																			>
																				<div
																					class="linegraph-subtext-subParent0"
																				>
																					{{ i.questionTag }}
																				</div>
																				<div
																					class="linegraph-subtext-subParent1"
																				>
																					{{ i.totalCount }}
																				</div>
																			</div>
																			<!-- hgyg -->
																			<div
																				class="d-flex align-items-center linegraph-subtext-child"
																			>
																				<div style="width: 90%">MCQ'S</div>
																				<div style="width: 10%">
																					{{ i.noOfMcq }}
																				</div>
																			</div>
																			<div
																				class="d-flex align-items-center linegraph-subtext-child"
																			>
																				<div style="width: 90%">
																					Match The Following
																				</div>
																				<div style="width: 10%">
																					{{ i.noOfmatchTheFollowing }}
																				</div>
																			</div>
																			<div
																				class="d-flex align-items-center linegraph-subtext-child"
																			>
																				<div style="width: 90%">
																					Descriptive
																				</div>
																				<div style="width: 10%">
																					{{ i.noOfDescriptive }}
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</b-overlay>
														</div>
													</div>
												</div>
											</div>
										</b-col>
									</b-row>
								</div>
							</div>
						</b-overlay>
					</div>
				</div>
				<div style="width: 20%; background: #f8f8f8">
					<div class="rep-overview-box ml-2">
						<div class="rep-overview-line"></div>
						<div class="rep-overview-text m-2">Overview</div>
					</div>
					<div class="rep-overview-subbox m-2">
						Topics
					</div>
					<div class="rep-overview-subbox mt-2 ml-2">
						Tests
					</div>

					<div class="rep-overview-subbox m-2 pointer">Groups</div>

					<div class="rep-overview-subbox m-2">
						Candidates
					</div>

					<div class="rep-overview-subbox m-2 mb-3 pointer">
						Individuals
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as d3 from "d3";
import {
	getOverallReports,
	getOverallActiveStudents,
	getTopicInformation,
	// scatterGraph2Api,
	// scatterGraph1Api,
	barApi,
	barCandidate,
	pieApi,
	treeGraphApi,
	scatterGraph1ApiAll,
	treeGraphFilters,
	groupDataTable,
} from "../../../utils/apiFunctions";

//Import GRAPH LINKS
import {
	piePlot,
	D3BarChart,
	treeGraph,
	// scatterplot,
	scatterplotZoom,
	// scatterplot_rect,
} from "vue-d3-charts-hire3x";

import Spinner from "../../../components/fixedcomponents/Spinner.vue";
import DatePicker from "vue2-datepicker";
import { getStatisticReports } from "../../../controllers/topics/asynchronous";
export default {
	// props: ['QuesData.name'],
	name: "OverallAssessment",
	components: {
		Spinner,
		// Register the imported DatePicker component
		"date-picker": DatePicker,
	},
	watch: {
		searchQuery() {
			this.scatter2func();
		},
		value1() {
			if (this.value1[0] != null) {
				if (
					this.filterSelected != "daily" ||
					this.filterSelected != "weekly" ||
					this.filterSelected != "yearly"
				) {
					this.selectCustDate();
				}
			}
		},

		//For search of particular Topic
		searchTopics(newSearchTopics) {
			let isGetTheParticularDataCalledZoom = false;
			this.chkconfig = false;

			let newTopics = newSearchTopics.toLowerCase();

			this.filteredTopics = this.zoomdata.filter((posts) => {
				if (this.zoomdata.includes(newTopics)) {
					if (!isGetTheParticularDataCalledZoom) {
						this.sp_circless.tipMouseoutZoom(this.myvalsZoom);
						this.getTheParticularDataScatter();
						isGetTheParticularDataCalledZoom = true;
					}
				} else {
					this.selectedTagZoom = "";
					this.sp_circless.tipMouseoutZoom(this.myvalsZoom);
				}
				return posts.includes(newTopics);
			});
		},

		//For search of particular Question Tag
		search(newSearch) {
			let isGetTheParticularDataCalled = false;
			let chkconfig = false;

			newSearch = newSearch.toLowerCase();
			this.filteredList = this.postList.filter((post) => {
				if (this.postList.includes(newSearch)) {
					if (!isGetTheParticularDataCalled) {
						isGetTheParticularDataCalled = true;
					}
				} else {
					this.selectedTag = "";
					// this.selectedFilteredTag = []
					this.den.mouseovereded("e", this.selectedTag);
					if (!chkconfig) {
						this.showQuesTag = false;
					}
				}
				return post.includes(newSearch);
			});
		},
	},

	data() {
		return {
			value1: "",
			quesDown: false,
			topicDown: false,
			loopVar: 30,
			// value1: [new Date()],
			value2: [],
			searchQuery: "",
			total: null,
			groupCounts: 6,
			pageStart: "",
			pageEnd: "",
			currentPage: 1,
			sortBy: "",
			ordering: -1,

			searchGroupTest: "",
			selectedFilteredTag: [],
			fullTaggedList: [], // Must be an array reference!

			//for search of topics
			sp_circless: new scatterplotZoom(),
			myvalsZoom: [],
			selectedTagZoom: [],
			zoomdata: [],
			searchTopics: "",
			filteredTopics: [],

			//for search of Question Tags
			den: new treeGraph(),
			myvalss: [],
			selectedTag: [],
			postList: [],
			search: "",
			filteredList: [],
			finalQuesTag: [],
			selectedTagPayload: [],
			startDate: "",
			endDate: "",

			liveValue: "",
			showSpinner: false,
			showSpinnerRect: false,
			showSpinnerScatter: false,
			showQuesTagSpinner: false,
			overlayOpacity: 4,
			testCandidate: false,
			name: "modal-component",
			quesName: "",
			filterSelected: "daily",
			filterOptions: [
				{
					text: "Daily",
					value: "daily",
				},
				{
					text: "Weekly",
					value: "weekly",
				},
				{
					text: "Yearly",
					value: "yearly",
				},
			],
			testfilterSelected: "all",
			testfilterOptions: [
				{
					text: "All",
					value: "all",
				},
				{
					text: "Weekly",
					value: "week",
				},
				{
					text: "Monthly",
					value: "month",
				},
				{
					text: "Yearly",
					value: "year",
				},
			],
			isLoading: true,
			details: {},
			topicsTableData: [],
			topicsTableFields: [
				{ key: "slNo", sortable: true, label: "Sl No." },
				{ key: "name", sortable: true, label: "Name" },
				{ key: "totalCandidates", sortable: true, label: "Total Tests Taken" },
				{ key: "totalTests", sortable: true, label: "Total Tests" },
			],
			starCandidates: [],
			//GRAPH PURPOSE
			allData: [],
			marks_data: [],
			svgWidth: window.innerWidth,

			max: 0,

			pie_data: [
				{ platform: "Android", percentage: 40.11 },
				{ platform: "Windows", percentage: 36.69 },
				{ platform: "iOS", percentage: 13.06 },
			],
			scatter_data: [],
			scatter2_data: [],
			activeTags: "topics",

			chkCount: 0,
			dataExist: false,
			chkCount2: 0,
			dataExist2: false,
			dataExist3: false,

			uniqueTopics: 0,
			uniqueGroups: 0,

			//For Navbar Data
			totalTopicCount: 0,
			totalTestCount: 0,
			totalCandidateCount: 0,
			totalGroupCount: 0,
			totalCandidatesAddedCount: 0,

			//For Pie Graph
			upcomingTest: 0,
			takenTest: 0,
			ongoingTest: 0,
			ongoingCandidate: 0,
			completedTest: 0,
			passCandidate: 0,
			failCandidate: 0,
			alreadyTakenTest: null,

			//loader
			LoaderStatus: false,
			//For Question Tags
			totalQuestions: 0,
			totalTags: 0,
			totalQuesTagCount: 0,
			actualTags: [],
			showQuesTag: false,
		};
	},
	beforeDestroy() {
		window.removeEventListener("liveValueUpdated", this.updateLiveValue);
		this.updateLiveValue = "";
	},
	async mounted() {
		this.drawChart();
		window.addEventListener("liveValueUpdated", this.updateLiveValue);

		try {
			this.piechartDraw1(); //API For PieChart Graph 3rd Graph
			//API ENDSS

			const response = await this.getData();
			this.isLoading = false;
			this.details = response.details;
			this.topicsTableData = response.topicsTableData;
		} catch (e) {
			console.error("Error getting data", e);
		}
	},
	async created() {
		this.LoaderStatus = true;
		this.getAllDataInfo();
		this.changeState();
		this.scatter2func();
		this.getAllOverallReport();
	},

	methods: {
		goTobackpage() {
			this.$router.go(-1);
		},
		//Once the tags will be added in the filtertag list User can remove it
		deleteTagsFromList(tag) {
			if (this.selectedFilteredTag.includes(tag)) {
				const index = this.selectedFilteredTag.indexOf(tag);
				if (index > -1) {
					// only splice array when item is found
					this.selectedFilteredTag.splice(index, 1); // 2nd parameter means remove one item only
					this.selectTaggedList(this.selectedFilteredTag);
				}
			}
		},

		//According to the tags selected. Might needed some changes
		makeNewLinkGraph() {
			this.selectTaggedList(this.selectedFilteredTag);
		},

		//Toogle between search of search of Ques tags
		toggleDropdownselectedQues() {
			this.quesDown = !this.quesDown;
			if (this.quesDown) {
				document.addEventListener("click", this.closeDropdownselectedGroup);
			} else {
				document.removeEventListener("click", this.closeDropdownselectedGroup);
			}
		},

		// For closing the dropdown of Ques tag Search
		closeDropdownselectedGroup(event) {
			if (
				this.$refs.expdropdownselectedGroup &&
				!this.$refs.expdropdownselectedGroup.contains(event.target)
			) {
				this.quesDown = false;
				document.removeEventListener("click", this.closeDropdownselectedGroup);
			}
		},

		//For order of Group table either in ascending or descending
		sort(data) {
			this.sortBy = data;
			if (this.ordering == 1) {
				this.ordering = -1;
			} else if (this.ordering == -1) {
				this.ordering = 1;
			}
			this.scatter2func();
		},

		//Go to the particular page if userf is clicking in the pagination
		goToPageNum() {
			this.scatter2func();
		},

		// Tree graph / Dendogram should get back to the original position on clearall button
		setBackLinkGraph() {
			if (this.search == "") {
				this.selectedFilteredTag = [];
				this.$forceUpdate();
			}
			this.graph4TreeGraphTimeline();
		},

		// After Selecting multiple tags from tag list the graph needs to get updated

		async selectTaggedList(val) {
			if (val && val.length !== 0) {
				await this.fetchAndDisplayTreeGraph(val);
			} else {
				this.graph4TreeGraphTimeline();
			}
		},

		async fetchAndDisplayTreeGraph(selectedTagPayload) {
			const graphQuesTimeline = this.getGraphQuesTimeline();

			try {
				const payloadQuestion = {
					timeline: graphQuesTimeline,
					startDate: this.startDate,
					endDate: this.endDate,
					filtertags: { tags: selectedTagPayload },
				};

				const quesTagRes = await treeGraphFilters(payloadQuestion);

				if (quesTagRes.status == 200) {
					this.processTreeGraphData(quesTagRes.data.data.tags);
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},

		getGraphQuesTimeline() {
			const possibleTimelines = ["daily", "weekly", "yearly"];
			return possibleTimelines.includes(this.filterSelected)
				? this.filterSelected
				: "custom";
		},

		processTreeGraphData(treeData) {
			if (treeData.length > 0) {
				const filteredTreeData = treeData.filter(
					(item) => item.imports.length > 1
				);
				const processedData =
					filteredTreeData.length >= 30 ? filteredTreeData : treeData;
				this.showTreeGraph(processedData);
				this.den.mouseovereded("e", this.selectedTag);
				this.dataExist3 = true;
			} else {
				this.showSpinner = false;
				this.dataExist3 = false;
			}
			this.showSpinner = false;
		},

		showTreeGraph(data) {
			this.showSpinner = true;
			this.shuffle(data);
			setTimeout(() => {
				const dendogramElement = document.getElementById("dendogram");
				if (dendogramElement && dendogramElement.innerHTML !== "") {
					dendogramElement.innerHTML = "";
				}
				this.den.dendoGram(data);
			}, 900);
		},

		//After getting clicked from js file each tag Window event will call this function
		async updateLiveValue(event) {
			this.showQuesTagSpinner = true;
			this.showQuesTag = true;
			this.liveValue = event.detail;
			this.actualTags = [];
			const graphQuesTimeline =
				this.filterSelected === "daily" ||
				this.filterSelected === "weekly" ||
				this.filterSelected === "yearly"
					? this.filterSelected
					: "custom";
			try {
				const payload = {
					timeline: graphQuesTimeline,
					startDate: this.startDate,
					endDate: this.endDate,
					tag: this.liveValue,
				};
				const res = await treeGraphApi(payload);
				if (res.status == 200) {
					this.totalQuesTagCount = res.data.data.tagsInfo.length;
					this.actualTags = res.data.data.tagsInfo;
					this.showQuesTagSpinner = false;
				}
			} catch (error) {
				console.log("one more error api");
			}
		},

		// For Highlighting the particular bubble after search result matches
		getTheParticularDataScatter() {
			for (let i in this.myvalsZoom) {
				if (
					this.myvalsZoom[i].topicName.toLowerCase() ===
					this.searchTopics.toLowerCase()
				) {
					this.selectedTagZoom = this.myvalsZoom[i];
					//Same variable should be used to call the method from .js File
					this.sp_circless.otherMouseover(
						"e",
						this.selectedTagZoom,
						i,
						this.myvalsZoom
					);
				}
			}
		},

		// The Opened div needs to close
		hideSearchTopics() {
			this.topicDown = false;
		},
		hideSearchQues() {
			this.quesDown = false;
		},
		reset_zoom() {
			this.graph1ScatterTimeline();
		},

		// ON clicking the particular topic name from the list
		copytheTopicName(name) {
			this.$refs.typeBox.focus();
			this.searchTopics = name;
		},

		copytheTagName(name) {
			this.selectedTag = "";
			this.$refs.typeBoxTag.focus();
			this.den.mouseovereded("e", this.selectedTag);
			this.search = name;
		},

		// For changing the tags from candidate to test and vice versa
		changeCandidateTest(id) {
			if (id === "tests") {
				this.testCandidate = false;
				this.testingfunction();
			} else {
				this.testCandidate = true;
				this.testingfunction();
			}
		},

		async getAllDataInfo() {
			getStatisticReports(this);
			//       // const originalData = response.data.data;
			//       // this.totalTopicCount = originalData.totalTopicsCreated;
			//       // this.totalTestCount = originalData.totalTestsCreated;
			//       // this.totalCandidateCount = originalData.candidatesTakenTest;
			//       // this.totalGroupCount = originalData.numberOfGroups;
			//       // this.totalCandidatesAddedCount = originalData.candidatesAddedCount;
			//     }
			// // }
			//   } catch (error) {
			//     throw new Error(`Failed! Status:${error.status}`);
			//   }
		},

		async getAllOverallReport() {
			try {
				const payload = {
					timeline: "yearly",
				};
				const response = await getOverallReports(payload);
				if (response.status == 200) {
					this.LoaderStatus = false;
					const originalData = response.data.data;

					this.totalTopicCount = originalData.numberOfTopics;
					this.totalTestCount = originalData.numberOfTests;
					this.totalCandidateCount = originalData.numberOfCandidatesTakenTest;
					this.totalGroupCount = originalData.numberOfGroups;

					this.totalCandidatesAddedCount = originalData.numberOfCandidatesAdded;
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},

		// For changing the timeline of Test and Candidate Bar graph
		async testingfunction() {
			if (!this.testCandidate) {
				if (this.testfilterSelected === "all") {
					this.drawChart();
				} else if (this.testfilterSelected === "week") {
					this.barFunc("weekly");
				} else if (this.testfilterSelected === "month") {
					this.barFunc("monthly");
				} else if (this.testfilterSelected === "year") {
					this.barFunc("yearly");
				}
			} else if (this.testCandidate) {
				if (this.testfilterSelected === "all") {
					this.barCandidateFunc("all");
				} else if (this.testfilterSelected === "week") {
					this.barCandidateFunc("weekly");
				} else if (this.testfilterSelected === "month") {
					this.barCandidateFunc("monthly");
				} else if (this.testfilterSelected === "year") {
					this.barCandidateFunc("yearly");
				}
			}
		},

		//To check If Particular Div is Empty
		chkNull(id) {
			const divElement = document.getElementById(id);

			if (divElement != null) {
				document.getElementById(id).innerHTML = "";
			} else {
				void 0;
			}
		},

		//Function to Change the state of Graphs According to Time
		async changeState() {
			if (this.filterSelected != "custom") {
				this.value1 = "";
			}
			this.quesDown = false;
			this.search = "";
			this.graph1ScatterTimeline();
			this.graph4TreeGraphTimeline();
		},

		async selectCustDate() {
			// this.filterSelected = 'custom'
			let theDate = [];
			for (let i in this.value1) {
				const now = this.value1[i];
				const year = now.getFullYear();
				const month = (now.getMonth() + 1).toString().padStart(2, "0");
				const day = now
					.getDate()
					.toString()
					.padStart(2, "0");
				theDate.push(`${year}-${month}-${day}`);
			}
			this.startDate = theDate[0];
			this.endDate = theDate[1];
			this.changeState();
		},

		//According to timeline
		async graph1ScatterTimeline() {
			this.searchTopics = ""; //For search topics in side
			this.chkCount = 0; //For 1st graph
			this.chkNull("graph1"); //If div is empty
			this.showSpinnerScatter = true;
			const graph1Timeline =
				this.filterSelected === "daily" ||
				this.filterSelected === "weekly" ||
				this.filterSelected === "yearly"
					? this.filterSelected
					: "custom";
			try {
				const payloadCombine = {
					timeline: graph1Timeline,
					startDate: this.startDate,
					endDate: this.endDate,
				};
				const resScatterCircle = await scatterGraph1ApiAll(payloadCombine);
				if (resScatterCircle.status == 200) {
					this.graph1InsideFunction(resScatterCircle);
				}
			} catch (error) {
				console.log("Error", error);
			}
		},
		graph1InsideFunction(resScatterCircle) {
			let scatter_data = resScatterCircle.data.data;
			let ran = Math.floor(Math.random() * scatter_data.topicData.length);
			let arr = [];

			for (let myItem of scatter_data.topicData) {
				if (arr.length == 0) {
					arr.push(ran);
				} else {
					while (arr.indexOf(ran) != -1) {
						ran = Math.floor(Math.random() * scatter_data.topicData.length);
					}
					arr.push(ran);
				}
				myItem.valueTemp = ran;
			}

			let ran2 = Math.floor(
				Math.random() * (scatter_data.topicData.length * 2)
			);
			let arr2 = [];
			for (let myItem2 of scatter_data.topicData) {
				if (arr2.length == 0) {
					arr2.push(ran2);
				} else {
					while (arr2.indexOf(ran2) != -1) {
						ran2 = Math.floor(Math.random() * scatter_data.topicData.length);
					}
					arr2.push(ran2);
				}
				myItem2.valueTempRandom = ran2;
			}
			this.uniqueTopics = scatter_data.totalNumberOfTopics;
			this.graph1InsideFunctionMakeGraph(scatter_data);
		},
		graph1InsideFunctionMakeGraph(scatter_data) {
			for (let x of scatter_data.topicData) {
				if (x.uniqueTotalCandidates >= 0) {
					this.chkCount = 1;
					this.dataExist = true;
					break;
				}
			}
			if (this.chkCount > 0) {
				setTimeout(() => {
					if (document.getElementById("graph1").innerHTML != "") {
						document.getElementById("graph1").innerHTML = "";
					}
					this.zoomdata = [];
					this.filteredTopics = [];

					//Call the Graph
					this.myvalsZoom = this.sp_circless.theZoom(scatter_data.topicData);

					//For searching Purpose
					for (let i in this.myvalsZoom) {
						this.zoomdata.push(this.myvalsZoom[i].topicName.toLowerCase());
					}
					this.filteredTopics = this.zoomdata;
				}, 200);
			} else {
				//If there is no data
				this.zoomdata = [];
				this.filteredTopics = [];
				this.dataExist = false;
			}
			this.showSpinnerScatter = false;
		},

		//Dendogram or treegraph according to Timeline
		async graph4TreeGraphTimeline() {
			this.actualTags = [];
			this.selectedFilteredTag = [];
			this.chkNull("dendogram");
			this.showSpinner = true;
			this.showQuesTag = false;
			this.dataExist3 = false;
			const graph1Timeline =
				this.filterSelected === "daily" ||
				this.filterSelected === "weekly" ||
				this.filterSelected === "yearly"
					? this.filterSelected
					: "custom";

			try {
				let payloadQuestion = {
					timeline: graph1Timeline,
					searchQuery: "",
					startDate: this.startDate,
					endDate: this.endDate,
				};
				const quesTagRes = await treeGraphApi(payloadQuestion);
				if (quesTagRes.status == 200) {
					this.insideTreeFunction(quesTagRes);
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},

		insideTreeFunction(quesTagRes) {
			let tree_data = quesTagRes.data.data.tags;
			this.totalQuestions = quesTagRes.data.data.totalQuestions;
			this.totalTags = quesTagRes.data.data.totaltags;
			if (tree_data.length > 0) {
				this.dataExist3 = true;
				this.shuffle(tree_data);
				setTimeout(() => {
					this.postList = [];
					this.fullTaggedList = [];
					let a = this.den.dendoGram(tree_data);
					const p = Promise.resolve(a);
					p.then((value) => {
						this.myvalss = value;
						for (const item of value) {
							this.postList.push(item.data.parentTag.toLowerCase());
							if (item.data.imports.length >= 1) {
								this.fullTaggedList.push(item.data.parentTag.toLowerCase());
								this.finalQuesTag.push(item.data.parentTag.toLowerCase());
							}
							this.den.mouseovereded("e", this.selectedTag);
						}
						this.filteredList = this.postList;
						this.fullTaggedList = this.fullTaggedList.sort();
						this.finalQuesTag = this.finalQuesTag.sort();
					}).catch((err) => {
						console.log(err);
					});
					this.showSpinner = false;
				}, 1000);
			} else {
				this.dataExist3 = false;
			}
			this.showSpinner = false;
		},

		scrollfunction(id, activeTagName) {
			this.activeTags = activeTagName;

			const element1 = document.getElementById(id);
			element1.scrollIntoView({ behavior: "smooth" });
		},
		handleTopicCardClick(topicId, totalTests, topicName) {
			let data = {
				topicName: topicName,
			};
			this.$store.commit("searchVUEX/saveReportDetails", data);
			if (totalTests === 0) {
				return;
			}
			this.$router.push({
				path: `/reports/topic/${topicId}`,
			});
		},

		async getData() {
			const values = await Promise.all([
				getTopicInformation(),
				getOverallActiveStudents(),
			]);
			values.forEach((data) => {
				if (data.data.type !== "Success") {
					throw new Error("Request Failed");
				}
			});
			return {
				details: values[0].data.data,
				topicsTableData: values[1].data.data,
				// starCandidates: values[2].data.data
			};
		},
		async piechartDraw1() {
			try {
				const res = await pieApi("daily");
				if (res.status == 200) {
					let pieData = res.data.data;

					this.upcomingTest = pieData.upcomingTest.upcomingTestCount;
					this.takenTest = pieData.upcomingTest.candidateCount;
					this.ongoingTest = pieData.ongoingTest.ongoingTestCount;
					this.ongoingCandidate = pieData.ongoingTest.candidateCount;
					this.completedTest = pieData.completedTest.completedTestCount;
					this.passCandidate = pieData.completedTest.passedCandidateCount;
					this.failCandidate = pieData.completedTest.failedCandidateCount;
					this.alreadyTakenTest = pieData.completedTest.candidateCount;

					let e = new piePlot();
					e.pieGraph("#pieChart", "pieChart", pieData);
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},

		async scatter2func() {
			this.showSpinnerRect = true;
			try {
				this.chkCount2 = 0;
				let payload = {
					searchQuery: this.searchQuery,
					timeline: "all",
					sortBy: this.sortBy,
					order: this.ordering, //1-> Ascending  || -1->Descending
					page: this.currentPage - 1,
					count: this.groupCounts,
				};
				const resScatterRect = await groupDataTable(payload);
				if (resScatterRect.status == 200) {
					this.scatter2_data = resScatterRect.data.data.data;
					this.total = resScatterRect.data.data.total;
					this.pageStart = resScatterRect.data.data.pageStart;
					this.pageEnd = resScatterRect.data.data.pageEnd;
					this.showSpinnerRect = false;
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},

		async drawChart() {
			document.getElementById("barchartGraph").innerHTML = "";

			let data = [];

			try {
				const res = await barApi("all");
				if (res.status == 200) {
					data = res.data.data;
				} else {
					console.log("We got error");
				}
			} catch (error) {
				console.log(error);
			}
			let margin = { top: 20, right: 0, bottom: 40, left: 40 };
			let selectorHeight = 40;
			let width = 1320;
			let height = 250 - margin.top - margin.bottom - selectorHeight;
			let heightOverview = 40;

			let elementWidth = 80;
			let numBars = Math.round(width / elementWidth);
			let isScrollDisplayed = elementWidth * data.length > width;

			let xScale = d3
				.scaleBand()
				.domain(
					data.slice(0, numBars).map(function(d) {
						return d.x_axis;
					})
				)
				.range([0, width])
				.padding(0.5);

			let yScale = d3
				.scaleLinear()
				.domain([
					0,
					d3.max(data, function(d) {
						return d.count;
					}),
				])
				.range([height, 0]);

			let xAxis = d3.axisBottom(xScale);
			let yAxis = d3.axisLeft(yScale).ticks(5);

			let svg = d3
				.select(".bar-chart-legend")
				.append("svg")
				.attr("width", width + margin.left + margin.right)
				.attr("height", height + margin.top + margin.bottom + selectorHeight);
			// .style("background-color", "red");

			let barChart = svg
				.append("g")
				.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

			barChart
				.append("g")
				.attr("class", "xAxis")
				.attr("transform", "translate(0, " + height + ")")
				.call(xAxis);

			barChart
				.append("g")
				.attr("class", "yAxis")
				.call(yAxis);

			let bars = barChart.append("g");

			bars
				.selectAll("rect")
				.data(data.slice(0, numBars), function(d) {
					return d.x_axis;
				})
				.enter()
				.append("rect")
				.attr("class", "bar")
				.attr("x", function(d) {
					return xScale(d.x_axis);
				})
				.attr("y", function(d) {
					return yScale(d.count);
				})
				.attr("width", xScale.bandwidth())
				.attr("height", function(d) {
					return height - yScale(d.count);
				});

			if (isScrollDisplayed) {
				let xOverview = d3
					.scaleBand()
					.domain(
						data.map(function(d) {
							return d.x_axis;
						})
					)
					.range([0, width])
					.padding(0.5);
				let yOverview = d3.scaleLinear().range([heightOverview, 0]);
				yOverview.domain(yScale.domain());

				let subBars = barChart.selectAll(".subBar").data(data);

				subBars
					.enter()
					.append("rect")
					.classed("subBar", true)
					.attr("height", function(d) {
						return heightOverview - yOverview(d.count);
					})
					.attr("width", function() {
						return xOverview.bandwidth();
					})
					.attr("x", function(d) {
						return xOverview(d.x_axis);
					})
					.attr("y", function(d) {
						return height + heightOverview + yOverview(d.count);
					});
				barChart
					.append("rect")
					.attr("transform", "translate(0, " + (height + margin.bottom) + ")")
					.attr("class", "mover")
					.attr("x", 0)
					.attr("y", 0)
					.attr("height", selectorHeight)
					.attr("width", Math.round(parseFloat(numBars * width) / data.length))
					.attr("pointer-events", "all")
					.attr("cursor", "ew-resize")
					.call(d3.drag().on("drag", display));
			}
			function display(event) {
				let displayed = d3
					.scaleQuantize()
					.domain([0, width])
					.range(d3.range(data.length));
				let x = parseInt(d3.select(this).attr("x")),
					nx = x + event.dx,
					w = parseInt(d3.select(this).attr("width")),
					f,
					nf,
					new_data,
					rects;

				if (nx < 0 || nx + w > width) return;

				d3.select(this).attr("x", nx);

				f = displayed(x);
				nf = displayed(nx);

				if (f === nf) return;

				new_data = data.slice(nf, nf + numBars);

				xScale.domain(
					new_data.map(function(d) {
						return d.x_axis;
					})
				);
				barChart.select(".xAxis").call(xAxis);

				rects = bars.selectAll("rect").data(new_data, function(d) {
					return d.x_axis;
				});

				rects.attr("x", function(d) {
					return xScale(d.x_axis);
				});

				// 	  rects.attr("transform", function(d) { return "translate(" + xScale(d.x_axis) + ",0)"; })

				rects
					.enter()
					.append("rect")
					.attr("class", "bar")
					.attr("x", function(d) {
						return xScale(d.x_axis);
					})
					.attr("y", function(d) {
						return yScale(d.count);
					})
					.attr("width", xScale.bandwidth())
					.attr("height", function(d) {
						return height - yScale(d.count);
					});

				rects.exit().remove();
			}
		},

		async barFunc(timeLinePassed) {
			try {
				const res2 = await barApi(timeLinePassed);
				if (res2.status == 200) {
					let full_data2 = res2.data.data;
					const allBarData2 = [];
					const max2 = Math.max(...full_data2.map((o) => o.count));
					const barColor = "#84BAE7";
					let xScaleDomain2 = full_data2.map((d) => d.x_axis);
					full_data2.forEach((element) => {
						allBarData2.push(element.count);
					});
					let chart2 = new D3BarChart();
					chart2.myData(full_data2, max2, allBarData2, xScaleDomain2, barColor);
					chart2.makegraph.linechart2();
				}
			} catch (error) {
				console.log("one more error api");
			}
		},

		//For Graph Of Candidate
		async barCandidateFunc(passedTimeline) {
			try {
				const res = await barCandidate(passedTimeline);
				if (res.status == 200) {
					let full_data = res.data.data;
					let allBarData = [];
					const max = Math.max(...full_data.map((o) => o.count));
					const barColor = "#E3607B";
					let xScaleDomain = full_data.map((d) => d.x_axis);
					full_data.forEach((element) => {
						allBarData.push(element.count);
					});
					let e = new D3BarChart();
					e.myData(full_data, max, allBarData, xScaleDomain, barColor);
					e.makegraph.linechart1();
				}
			} catch (error) {
				console.log("one more error api");
			}
		},

		shuffle(array) {
			let currentIndex = array.length,
				randomIndex;

			// While there remain elements to shuffle.
			while (currentIndex != 0) {
				// Pick a remaining element.
				randomIndex = Math.floor(Math.random() * currentIndex);
				currentIndex--;

				// And swap it with the current element.
				[array[currentIndex], array[randomIndex]] = [
					array[randomIndex],
					array[currentIndex],
				];
			}

			return array;
		},
	},
};
</script>

<style>
.btn-outline-secondary:focus,
.btn-outline-secondary.focus {
	box-shadow: unset !important;
}

.tot-count {
	font-weight: 700;
	font-size: 20px;
	color: #3379b3;
}

.totgrp-txt {
	font-weight: 500;
	font-size: 14px;

	color: #343434;
}

.tot-grp-box {
	padding: 10px;
	background: rgba(215, 215, 215, 0.42);
	border-radius: 8px;
}

.overalltestprog-container-headtext {
	font-weight: 600;
	font-size: 18px;
	color: #696969;
}

.overalltestprog-container {
	background: rgba(248, 248, 248, 0.42);
	border-radius: 0px 0px 8px 8px;
	height: 300px;
	padding: 10px;
}

.reptest .btn-outline-secondary:not(:disabled):not(.disabled):active,
.reptest .btn-outline-secondary:not(:disabled):not(.disabled).active,
.reptest .show > .btn-outline-secondary.dropdown-toggle {
	font-weight: 500;
	font-size: 12px;
	color: #3379b3;
	border-bottom: 5px solid #3379b3 !important;
	width: fit-content;
	border-radius: 5px;
	background: #ffffff;
}

.reptest .btn-outline-secondary {
	font-weight: 500;
	font-size: 12px;
	line-height: 18px;
	color: #696969;
	border-color: #6c757d;
}

.reptest .btn-outline-secondary:hover {
	background-color: unset !important;
	border-color: unset !important;
}

.reptest .btn {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	border: unset !important;
}

.rep-tst-headcard {
	background: #f2f2f2;
	font-weight: 600;
	font-size: 14px;
	position: relative;
	width: 125px;

	height: 35px;
	color: #1a4164;
}

.rep-test-gridcolor {
	position: absolute;

	left: 0;
	top: 0;
	width: 5px;

	height: 35px;
	background: #514b4b;
}

.rep-txt-viewalltxt {
	font-weight: 600;
	font-size: 14px;
	text-decoration-line: underline;
	color: #72738e;
	position: absolute;
	bottom: 5px;
	right: 5px;
}

.rep-tp-tw-txt {
	font-weight: 500;
	font-size: 12px;
	color: #343434;
}

.rep-tp-count {
	font-weight: 600;
	font-size: 22px;
	color: #343434;
	overflow-x: auto;
	overflow-y: hidden;
}

.rep-graph-twenty {
	width: 25%;
	background: #ffffff;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
	border-radius: 8px;
}

.rep-graph-seventy {
	background: rgba(248, 248, 248, 0.42);
	border-radius: 8px;
	width: 75%;
	overflow-x: auto;
	overflow-y: hidden;
}

.bar-graph-class {
	height: 250px;
	overflow-x: auto;
	overflow-y: hidden;
}

.rep-tp-graph-container {
	background: #ffffff;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
	border-radius: 8px;
	height: 300px;
}

.rep-tp-subtxt {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}

.rep-tp-headtext {
	font-weight: 600;
	font-size: 20px;
	color: #464667;
}

.rep-overview-container {
	height: calc(100vh - 310px);
	overflow: auto;
	padding-right: 5px;
}

.rep-topic-conatiner {
	background: #ffffff;
	border: 1px solid #eeeeee;
	box-shadow: 0px -1px 8px rgba(0, 0, 0, 0.05);
}

.rep-test-conatiner {
	background: #ffffff;
	border: 1px solid #eeeeee;
	box-shadow: 0px -1px 8px rgba(0, 0, 0, 0.05);
}

.rep-overview-subbox {
	height: 45px;
	padding: 10px;
	background: #fcfeff;
	font-weight: 500;
	font-size: 14px;
	color: #3379b3;
}

.rep-overview-box {
	height: 64px;
	background: #eef7ff;
}

.rep-overview-line {
	background: #ddf0ff;
	height: 6px;
}

.rep-c-activeline {
	background: #7e7ece;
	border: 1px solid #eeeeee;
	box-shadow: 0px -1px 8px rgb(0 0 0 / 5%);
	border-radius: 5px;
	height: 6px;
	position: absolute;
	width: 100%;
	bottom: 0;
	left: 0;
}

.expandicon {
	position: absolute;
	bottom: -5px;
	right: 0px;
}

.rep-c-mainhead {
	font-weight: 600;
	font-size: 14px;
	color: #696969;
}

.rep-c-counttxt {
	font-weight: 600;
	font-size: 28px;
	color: #7e7ece;
	margin-top: 10px;
}

.rep-c-subhead {
	font-weight: 300;
	font-size: 12px;
	margin-top: 5px;
	color: #72738e;
}

.rep-chota-cards {
	background: #ffffff;
	border: 1px solid #eeeeee;
	box-shadow: 0px -1px 8px rgba(0, 0, 0, 0.05);
	border-radius: 5px;
	height: 120px;
	padding: 10px;
}

.reports-top-bar
	.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-secondary.dropdown-toggle:focus {
	box-shadow: unset !important;
}

.reports-top-bar.btn-outline-secondary {
	color: #696969;
	border-color: #efefef;
}

.reports-top-bar .btn {
	border-radius: 0px;
	font-weight: 500;
	font-size: 12px;
	width: 100px;
	background: #ffffff;
}

.reports-top-bar .btn-outline-secondary:hover {
	color: #696969;
}

.reports-top-bar .btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
	font-weight: 500;
	font-size: 12px;

	color: #ffffff;
	border-color: unset;
	background: #72738e;
	width: 100px;
	border-radius: 4px 0px 0px 4px;
}

.reports-top-bar {
	background: #ffffff;
	border: 1px solid #eeeeee;
	box-shadow: 0px -1px 8px rgba(0, 0, 0, 0.05);
	border-radius: 5px;
	height: 50px;
	padding: 10px;
}

.rep-overview-text {
	font-weight: 600;
	font-size: 16px;
	line-height: 31px;
	color: #464667;
}

/* STYLE FOR DENDOGRAM */
.node {
	font: 600 25px "Poppins", sans-serif;
	fill: #696969;
}

.node:hover {
	fill: #3379b3;
}

.link {
	stroke: #eec200;
	stroke-opacity: 0.9;
	fill: none;
	pointer-events: none;
	visibility: visible;
}

.node:hover,
.node--source,
.node--target {
	font-weight: 20;
}

.node--source {
	fill: #2ca02c;
	background-color: red;
	visibility: visible;
}

.node--target {
	fill: #d62728;
	visibility: visible;
}

.link--source,
.link--target {
	stroke-opacity: 1;
	stroke-width: 2px;
}

.link--source {
	stroke: #d62728;
	visibility: visible;
}

.link--target {
	stroke: #2ca02c;
	visibility: visible;
}

.overallasmntreports div.tooltip {
	position: absolute;
	text-align: center;
	width: auto;
	height: auto;
	padding: 2px;
	font: 22px sans-serif;
	background: rgba(0, 100, 100, 0.4);
	border: 0px;
	border-radius: 8px;
	pointer-events: none;
}

.svg-container {
	display: flex;
	position: relative;
	width: 100%;
	height: 100%;
	vertical-align: top;
}

.svg-containerRect {
	display: flex;
	position: relative;
	width: 100%;
	height: 100%;
	vertical-align: top;
}
/* overall test progress */
.repotp-test-bar-container {
	background: #ffffff;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
	border-radius: 8px;
}

.rep-otp-uptest-txt {
	font-weight: 700;
	font-size: 20px;
	color: #ffc145;
}

.rep-otp-ongngtest-txt {
	font-weight: 700;
	font-size: 20px;
	color: #3379b3;
}

.rep-otp-comp-txt {
	font-weight: 700;
	font-size: 20px;
	color: #33a02c;
}

.rep-otp-subhead {
	font-weight: 500;
	font-size: 14px;
	color: #343434;
}

.rep-otp-desc {
	font-weight: 400;
	font-size: 12px;
	color: #696969;
}

.bar-x-axis {
	color: #f0f0f0;
}

.scatter-header {
	background: #ffffff;
	backdrop-filter: blur(25px);
	border-radius: 5px 5px 0px 0px;
	font-weight: 600;
	font-size: 14px;
	padding: 15px;
	color: #8676ff;
	min-width: 200px;
	max-width: 300px;
}

.scatterbody-content {
	background: #8676ff;
	box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.4);
	border-radius: 5px;
	padding: 10px;
	min-width: 200px;
	max-width: 300px;
}

.scatter-main {
	box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.4);
}

.scatter-texthead {
	font-weight: 400;
	font-size: 14px;
	color: #ffffff;
}

.scatter-textbody {
	font-weight: 400;
	font-size: 10px;

	color: #ffffff;
}

.scatter-testnum {
	font-weight: 600;
	font-size: 14px;

	color: #ffffff;
}

/* Rectangle scatter */
.scatter2-header {
	background: #ffffff;
	backdrop-filter: blur(25px);
	border-radius: 5px 5px 0px 0px;
	font-weight: 600;
	font-size: 14px;
	padding: 15px;
	color: #464667;
	min-width: 200px;
	max-width: 300px;
}

.scatterbody2-content {
	background: #000000;
	box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.4);
	border-radius: 5px;
	padding: 10px;
	min-width: 200px;
	max-width: 300px;
}

.activeText {
	font-weight: 400;
	font-size: 12px;
	color: #adaaaa;
	width: 70%;
}

.overall-asmnt-main-container {
	height: calc(100vh - 90px);
	position: relative;

	padding-left: 20px;
	padding-right: 10px;
	padding-top: 10px;
}

.overall-asmnt-bg {
	background: #f8f8f8;
	position: relative;
	top: 70px;
	padding-left: 60px;
	height: calc(100vh - 70px);
}

.svg-content {
	display: inline-block;
	position: absolute;
	top: 0;
	left: 0;
}

.svg-content-responsive {
	display: inline-block;
	position: relative;
	top: 10px;
	left: 0;
}

.zoom-in {
	cursor: url("..//..//..//assets//realMagnify.png"), auto;
}

.reports-heading {
	height: 70px;
	width: 320px;
	background: #eaeff3;
	backdrop-filter: blur(25px);
	/* Note: backdrop-filter has minimal browser support */

	border-radius: 5px 5px 0px 0px;
	box-shadow: 0px 1px 10px #9f9f9f;
}

.linegraph-text {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 14px;

	color: #464667;
}

.linegraph-subtext {
	background: rgba(252, 252, 252, 0.95);
	border-radius: 5px 5px 1.51899px 1.51899px;
}

.reports-lineGraphallText {
	min-height: auto;
	max-height: 375px;
	width: 100%;
	background: rgba(255, 255, 255, 0.95);
	box-shadow: 0px 1px 10px #9f9f9f;
	border-radius: 5px 5px 1.51899px 1.51899px;
	overflow-x: hidden;
	overflow-y: auto;
}

.linegraph-subtext-Parent {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 600;

	line-height: 14px;
	padding: 2%;
	margin-left: 2%;
}

.linegraph-subtext-subParent0 {
	font-size: 14px;
	color: #0acf97;
	width: 90%;
}

.linegraph-subtext-subParent1 {
	font-size: 12px;
	color: #696969;
	width: 10%;
}

.linegraph-subtext-child {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 14px;
	color: #696969;
	padding: 2%;
	margin-left: 2%;
}

.linegraphColorbar {
	position: absolute;
	background: #0acf97;
	width: 4px;
	height: 95%;
	border-radius: 8px;
	left: 2px;
	top: 3px;
}

.rectScroll {
	overflow-x: auto;
	overflow-y: hidden;
}

/* Topics Search Classes */
.grp-second-section {
	display: flex;
	align-items: center;
	border-radius: 3px;
	border: 0.5px solid #c4c4c4;
	background: #fff;
	box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2) inset;
}

.tags-second-section {
	display: flex;
	align-items: center;
	border-top: 1px solid #e2e2e2;
	border-bottom: 1px solid rgba(114, 115, 142, 0.4);
}
.grp-search-bar-search {
	width: 100%;
	display: flex;
}

.grp-search-bar-searchicon {
	position: relative;
	color: #a2a2a2;
}

.grp-search-bar-searchbtn {
	position: relative;
	border: none;
	border-radius: 0;
	background-color: transparent;
}

.grp-search-bar-searchbtn:focus {
	background-color: transparent;
	box-shadow: 0 0 0 0;
}

.grp-candidates-overflow {
	z-index: 2;
	overflow: auto;
	min-height: auto;
	max-height: calc(100vh - 701px);
	border-radius: 5px;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	background: #fff;
	box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.12);
}

.grp-tagss-overflow {
	overflow: auto;
	min-height: auto;
	max-height: calc(100vh - 750px);
	background: #f8f8ff;
}

.grp-tagsFilter-overflow {
	z-index: 2;
	position: absolute;
	overflow-x: hidden;
	overflow-y: auto;
	min-height: auto;
	max-height: calc(100vh - 650px);
	border-radius: 5px;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	background: #fff;
	box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.12);
}

.grp-tagged-test-head {
	font-weight: 500;
	font-size: 12px;
	color: #72738e;
}

.grp-mail-link {
	font-weight: 600;
	font-size: 11px;
	color: #696969;
}

.asmntForm-table thead {
	background: #e6e9ef;
	font-size: var(--size-14);
}
.asmntForm-table tbody {
	display: block;
	background: #ffffff;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	height: calc(100vh - 225px);
	width: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	padding: 10px;
}
.asmntForm-table thead,
.asmntForm-table tbody tr {
	display: table;
	position: relative;
	width: 100%;
	margin-top: 15px;
	table-layout: fixed;
}

.asmntForm-table tbody td .custom-control {
	padding-left: 43px;
}

.asmntForm-table thead th {
	font-weight: 600 !important;
	font-size: 14px !important;
	padding-top: 5px !important;
	padding-bottom: 5px !important;
}
.overall-asmnt-main-container .row {
	width: 100%;
	margin-left: 0;
	margin-right: 0;
}
.overall-asmnt-main-container .col {
	width: 100%;
	padding-left: 0;
	padding-right: 0;
}
.ovall-paginaTion {
	position: absolute;
	width: 97%;
	padding: 5px 10px;
	bottom: 10px;
	box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
	border-radius: 0px 0px 5px 5px;
	background: #f2f4fd;
	z-index: 1;
}

.ovall-group-card {
	background-color: #fff;
}

.ovall-search-bar .search-input {
	box-sizing: border-box;
	padding: 0 30px !important;
	width: 100%;
	border-radius: 3px;
	border: 0.5px solid #c4c4c4;
	background: #fff;
	box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2) inset;
}

.ovall-search-bar .form-control:focus {
	border: 0.5px solid #c4c4c4 !important;
	box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2) inset !important;
}

.ovall-form-table tbody {
	display: block;
	padding-bottom: 40px;
	height: calc(100vh - 515px);
	width: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	padding-right: 10px;
}

.ovall-form-table tbody tr {
	display: table;
	position: relative;
	width: 100%;
	margin-top: 15px;
	table-layout: fixed;
}

.ovall-form-table thead {
	border-radius: 8px 8px 0px 0px;
	background: #eef2f5;
	font-size: var(--size-14);
	color: #696969;
	display: table;
	position: relative;
	width: 100%;
	table-layout: fixed;
}

.ovall-table-details {
	background: #fcfcfc;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.ovall-table-details td {
	padding-top: 15px;
	padding-bottom: 15px;
	font-weight: 500;
	font-size: 13px;
	color: #696969;
}

.ovall-reset-btn {
	padding: 7px 20px;
	color: #696969;
	font-size: 14px;
	font-weight: 500;
	border-radius: 3px;
	border: 0.5px solid #c4c4c4;
	background: #fff;
	box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2) inset;
}
.ovall-width {
	width: 100%;
}

.ovall-selectdropdown option {
	padding: 5px;
}

.ovall-selectdropdown .custom-control:nth-child(odd) {
	font-weight: 400;
	font-size: 13px;
	color: #545454;
	background: #f4f4f4;
	padding-left: 2rem;
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
}

.ovall-selectdropdown .custom-control:nth-child(even) {
	font-weight: 400;
	font-size: 13px;
	color: #545454;
	background: var(--bg-white);
	padding-left: 2rem;
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
}

.ovall-selected {
	width: 100%;
	background-color: #f4f4f4;
	padding: 4px;
}

.ovall-selectedTags {
	background: red;
}
.ovall-UnselectedTags {
	background: #e6e6e6;
}
.ovall-tags {
	border-radius: 14px;
	padding: 3px 12px;
	color: #72738e;
	font-size: 12px;
	font-weight: 500;
	margin: 5px;
}

.parent-1 .mx-input {
	display: inline-block;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	width: 100%;
	height: 32px;
	padding: 6px 30px;
	padding-left: 10px;
	font-size: 13px;
	line-height: 1.4;
	color: #6c757d;
	background-color: #fff;
	border: 1px solid #6c757d;
	border-radius: 0px;
	-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}

.parent-2 .mx-input {
	display: inline-block;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	width: 100%;
	height: 32px;
	padding: 6px 30px;
	padding-left: 10px;
	font-size: 13px;
	line-height: 1.4;
	color: #ffffff !important;
	background-color: #72738e;
	border: 1px solid #72738e;
	border-radius: 0px;
	-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}

.parent-1 .mx-datepicker-range {
	width: 110px !important;
}

.parent-2 .mx-datepicker-range {
	width: 220px !important;
}
.parent-2 .mx-icon-calendar,
.mx-icon-clear {
	color: white !important;
}

.colorline {
	height: 20px;
	width: 3px;
	background: #0acf97;

	margin-left: 0px;
	margin-right: 10px;
}
.countDivOne {
	margin-right: 15px;
	background: rgba(252, 252, 252, 0.95);
}
.countDiv {
	display: flex;
	justify-content: space-between;
	padding: 10px;
	font-weight: 400;
	font-size: 10px;
	line-height: 14px;
	color: #696969;
	align-items: center;
	border-radius: 5px;
}

.bar-chart-legend {
	margin-bottom: 4rem;
	padding-bottom: 2rem;
	overflow-x: auto;
	overflow-y: hidden;
}
.bar {
	fill: #84bae7;
}

.subBar {
	fill: gray;
	opacity: 0.5;
}

.axis path,
.axis line {
	fill: none;
	stroke: #000;
	shape-rendering: crispEdges;
}

.brush .extent {
	stroke: blue;
	fill: tomato;
	fill-opacity: 1;
	shape-rendering: crispEdges;
}

rect.mover {
	stroke: #346a97;
	stroke-opacity: 0.1;
	fill: #c0f6ff;
	fill-opacity: 0.5;
}
@import "~vue2-datepicker/index.css";
</style>
